import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      gsap.registerPlugin( ScrollTrigger );
      let navHeight = $( '.navbar' ).outerHeight();
      let triggerPos = $( '.photographer-jump-links' ).outerHeight();

      if ( $( '#wpadminbar' ).length ) {
        navHeight += $( '#wpadminbar' ).outerHeight();
      }

      triggerPos += navHeight;

      // $( '.photographer-jump-links' ).css( 'top', navHeight );

      $( '.alpha-group' ).each( function() {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top ' + triggerPos,
            end: 'bottom ' + triggerPos,
            scrub: 0,
            toggleClass: {
              targets: $( '.photographer-jump-links a[href="#' + $( this ).attr( 'id' ) + '"]' )[0],
              className: 'is-active',
            },
          },
        } );
      } );

      $( '.photographer-jump-links a' ).click( function() {
        if ( location.pathname.replace( /^\//, '' ) === this.pathname.replace( /^\//, '' ) && location.hostname === this.hostname ) {
          let target = $( this.hash );
          let wpadminBarHeight = 0;
          if ( $( '#wpadminbar' ).length > 0 ) {
            wpadminBarHeight = $( '#wpadminbar' ).outerHeight();
          }
          const headerHeight = $( 'header.navbar' ).outerHeight();
          target = target.length ? target : $( '[name=' + this.hash.slice( 1 ) +']' );
          if ( target.length ) {
            $( 'html, body' ).animate( {
              scrollTop: target.offset().top - ( headerHeight + wpadminBarHeight + $( '.photographer-jump-links' ).outerHeight() - 15 ),
            }, 1000 );
            return false;
          }
        }
      } );

      $( '.photo-credit' ).each( function() { // the containers for all your galleries
        $( this ).magnificPopup( {
          delegate: 'a', // the selector for gallery item
          type: 'image',
          gallery: {
            enabled: true,
          },
        } );
      } );
    },
    finalize: function() {
    },
  };
  app.registerComponent( 'photo-credits', COMPONENT );
} )( app );
